export enum DocumentType {
  CC = 'CC',
  NIT = 'NIT',
  CE = 'CE',
  PASSPORT = 'PASSPORT',
  PPT = 'PPT',
}

export const documentTypeList: { value: string; name: string }[] = [
  { value: 'CC', name: 'Cédula de Ciudadanía' },
  { value: 'CE', name: 'Cédula de extranjería' },
  { value: 'PASSPORT', name: 'Pasaporte' },
  { value: 'NIT', name: 'NIT' },
  { value: 'PPT', name: 'PPT' },
];

export interface CIFINUserModel {
  documentType: DocumentType;
  documentNumber: number;
  expeditionDate: string;
}

export interface AttempsUserResponse {
  success: boolean;
  message: string;
  data: {
    documentype: DocumentType;
    documentnumber: number;
    documentdate: string;
    attempts: number;
    insertionStatus: boolean;
  };
}

export interface CIFINUserResponse {
  success: boolean;
  message: string;
  data: {
    source: string;
    code: string;
    valid: boolean;
    registerName: boolean;
    changeName: boolean;
    nombres: string;
    apellidos: string;
  };
}

export interface UserState {
  firstName?:string,
  lastName?:string,
  identificationNumber?: string,
  identificationType?: string,
  channel?: string,
  isPersonalDataStorageAllowed?: boolean,
  email?: string,
  birthday?: string | null,
  profileType?: string,
  iccid?: string,
  identityVerified?: boolean,
  issueDate?: string | null
}
